module.exports = __webpack_public_path__ + "static/media/report_1.f2d97129.svg";